<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="
        showAll ? companyList : companyList.filter((i) => i.isActive == 1)
      "
      :search="search"
      sort-by="name"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Firma listesi</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Veri Ara"
            hide-details
            style="width: 20%"
          ></v-text-field>

          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <v-switch
            v-model="showAll"
            :dense="false"
            style="padding-top: 3.5%;margin-right:1%"
          >
            <template #prepend>
              <v-label><p style="padding-top:2px;">Tümünü Göster</p></v-label>
            </template>
          </v-switch>

          <v-btn outlined color="primary" @click="loadCompaniesList()"
            ><v-icon>refresh</v-icon></v-btn
          >
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" width="1000px">
            <template v-slot:activator="{ on }">
              <v-btn outlined color="primary" v-on="on">Yeni Firma</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Yeni Firma Kaydı</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-stepper v-model="currStep" class="elevation-0">
                    <v-stepper-header class="elevation-0">
                      <template>
                        <v-stepper-step :complete="false" :step="1" editable>
                          Firma Bilgileri
                        </v-stepper-step>
                        <v-divider></v-divider>
                      </template>

                      <template>
                        <v-stepper-step :complete="false" :step="2" editable>
                          Firma Admin Bilgileri
                        </v-stepper-step>
                        <v-divider></v-divider>
                      </template>

                      <template>
                        <v-stepper-step :complete="false" :step="3" editable>
                          Yeminli Mali Müşavir Bilgileri
                        </v-stepper-step>
                        <v-divider></v-divider>
                      </template>

                      <template>
                        <v-stepper-step :complete="false" :step="4" editable>
                          Program Ayarları
                        </v-stepper-step>
                        <v-divider></v-divider>
                      </template>
                    </v-stepper-header>
                    <v-stepper-items>
                      <v-stepper-content :step="1">
                        <v-form ref="newCompanyInfo">
                          <v-row>
                            <v-col cols="3">
                              <v-text-field
                                v-model="newCompanyTemplate.name"
                                label="Ad-Soyad / Ünvan"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                v-model="newCompanyTemplate.info.taxOffice"
                                label="Vergi Dairesi"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                v-model="newCompanyTemplate.tinNumber"
                                label="Vergi Kimlik Numarası"
                                :rules="[rules.required, rules.tinNumber]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                v-model="newCompanyTemplate.info.city"
                                label="Şehir"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                v-model="newCompanyTemplate.info.address"
                                label="Adres"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                v-model="newCompanyTemplate.info.sector"
                                label="Sektör"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                v-model="newCompanyTemplate.info.fax"
                                label="Fax"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                v-model="newCompanyTemplate.info.telephone"
                                label="Telefon"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-stepper-content>

                      <v-stepper-content :step="2">
                        <v-form ref="newCompanyAdmin">
                          <v-row>
                            <v-col cols="4">
                              <v-text-field
                                v-model="newCompanyTemplate.admin.name"
                                label="Adı"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="newCompanyTemplate.admin.email"
                                label="Email"
                                :rules="[rules.required, rules.email]"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-stepper-content>

                      <v-stepper-content :step="3">
                        <v-form ref="newCompanyCharAcc">
                          <v-row>
                            <v-col cols="3">
                              <v-text-field
                                v-model="newCompanyTemplate.charAcc.name"
                                label="Adı"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                v-model="newCompanyTemplate.charAcc.lastName"
                                label="Soyadı"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                v-model="newCompanyTemplate.charAcc.email"
                                label="Email"
                                :rules="[rules.required, rules.email]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-row>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model="newCompanyTemplate.charAcc.chamber"
                                    style="padding:0"
                                    label="Oda"
                                    :rules="[rules.required]"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model="newCompanyTemplate.charAcc.regNo"
                                    style="padding:0"
                                    label="Sicil No"
                                    :rules="[rules.required]"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="3">
                              <v-text-field
                                v-model.number="
                                  newCompanyTemplate.charAcc.sealNo
                                "
                                label="Mühür Numarası"
                                :rules="[rules.required, rules.isNumber]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                v-model.number="newCompanyTemplate.charAcc.tinNumber"
                                label="Vergi Kimlik Numarası"
                                :rules="[rules.required, rules.isNumber]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                v-model="newCompanyTemplate.charAcc.taxOffice"
                                label="Vergi Dairesi"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                v-model="
                                  newCompanyTemplate.charAcc.bureauAddress
                                "
                                label="Büro Adresi"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="3">
                              <v-text-field
                                v-model="newCompanyTemplate.charAcc.telephone"
                                label="Telefon"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                v-model="newCompanyTemplate.charAcc.fax"
                                label="Fax"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-menu
                                ref="menu1"
                                v-model="dateMenu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="newCompanyTemplate.charAcc.contractDate"
                                    label="KDV İade Sözleşme Tarihi"
                                    persistent-hint
                                    v-bind="attrs"
                                    v-on="on"
                                    :rules="[rules.required]"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="newCompanyTemplate.charAcc.contractDate"
                                  no-title
                                  locale="tr-tr"
                                  @input="dateMenu = false"
                                  @blur="newCompanyTemplate.charAcc.contractDate = parseDate(newCompanyTemplate.charAcc.contractDate)"
                                  :rules="[rules.required]"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                v-model="newCompanyTemplate.charAcc.contractCount"
                                label="KDV İade Sözleşme Sayısı"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-stepper-content>

                      <v-stepper-content :step="4">
                        <v-form ref="newCompanySettings">
                          <v-row>
                            <v-col cols="2">
                              <v-select
                                v-model="
                                  newCompanyTemplate.settings.algorithmType
                                "
                                label="Algoritma Tipi"
                                :items="algorithmTypes"
                                hide-details
                                :rules="[rules.required]"
                              ></v-select>
                            </v-col>
                            <v-col cols="2">
                              <v-select
                                v-model="newCompanyTemplate.settings.yuklenimSelection
                                "
                                label="İndirilecek KDV Listesi"
                                :items="kdvRateSelectionItems"
                                hide-details
                                :rules="[rules.required]"
                              ></v-select>
                            </v-col>
                            <v-col cols="2">
                              <v-menu
                                ref="DeadLineDateMenu"
                                v-model="DeadlineDateMenu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="newCompanyTemplate.charAcc.expirationDate"
                                    label="Son Kullanma Tarihi"
                                    persistent-hint
                                    v-bind="attrs"
                                    v-on="on"
                                    :rules="[rules.required]"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="newCompanyTemplate.charAcc.expirationDate"
                                  no-title
                                  locale="tr-tr"
                                  @input="DeadlineDateMenu = false"
                                  @blur="newCompanyTemplate.charAcc.expirationDate = parseDate(newCompanyTemplate.charAcc.expirationDate)"
                                  :rules="[rules.required]"
                                ></v-date-picker>

                              </v-menu>
                            </v-col>
                            <v-col cols="3">
                              <v-checkbox
                              style=" margin-left:1%"
                              v-model="periodCheckBox"
                              label="Dönem Aralığı"
                              ></v-checkbox>
                            </v-col>
                            <v-col cols="3">
                              <v-btn 
                                @click="databaseChoiceDialog = true"
                                color="primary"
                              >
                                Veri Tabanı Seçimi
                              </v-btn>
                            </v-col>
                             <v-col cols="3">
                              <v-checkbox
                                style=" margin-left:1%"
                                v-model="exemptCompanyCheckBox"
                                label="Muaf Şirket Ata"
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                  <!---------->
                </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close()"
                    >İptal</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="nextStep()">{{
                    `${stepsCount > currStep ? "Devam" : "Kaydet"}`
                  }}</v-btn>
                </v-card-actions>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-dialog v-model="periodDialog" width="35%" persistent>
          <v-card>
            <v-card-title>
              <span>{{ "Kısıtlama İçin Dönem Aralığı Giriniz" }}</span>
            </v-card-title>
            <v-form v-model="valid">
              <v-container>
                <v-row>
                  <v-col cols="12" md="6" style="padding-left: 12;padding-right: 12;padding-bottom: 0;padding-top: 0">
                    <v-dialog
                      ref="dialog"
                      v-model="modal"
                      :return-value.sync="startingPeriod"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="startingPeriod"
                          label="Başlangıç Dönemi"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="startingPeriod"
                        type="month"
                        scrollable
                        locale="tr"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false">İptal</v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(startingPeriod)">Tamam</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="12" md="6" style="padding-left: 12;padding-right: 12;padding-bottom: 0;padding-top: 0">
                    <v-dialog
                      ref="dialog1"
                      v-model="modal1"
                      :return-value.sync="endPeriod"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="endPeriod"
                          label="Bitiş Tarihi"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="endPeriod"
                        type="month"
                        scrollable
                        locale="tr"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal1 = false">İptal</v-btn>
                        <v-btn text color="primary" @click="$refs.dialog1.save(endPeriod)">Tamam</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="periodDialogClose(0)">İptal</v-btn>
              <v-btn
                :disabled="!valid"
                color="blue darken-1"
                text
                @click="periodDialogClose(1)"
                >Kaydet</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:item.isActive="{ item }">
        <v-icon
          medium
          v-if="item.isActive == 1"
          @click="changeStatus(item.id, 0)"
          >check</v-icon
        >
        <v-icon
          medium
          v-else-if="item.isActive == 0"
          @click="changeStatus(item.id, 1)"
          >close</v-icon
        >
      </template>
      <template v-slot:item.workersNumber="{ item }">
        <center>{{ item.tUserCompanies.length }}</center>
      </template>
      <template v-slot:item.city="{ item }">
        <center>{{ item.info.city }}</center>
      </template>
      <template v-slot:item.sector="{ item }">
        <center>{{ item.info.sector }}</center>
      </template>
      <template v-slot:item.detay="{ item }">
        <v-icon medium @click="companyDetailsModal(item)">description</v-icon>
      </template>
      <template v-slot:item.delete="{ item }">
        <v-icon medium @click="deleteCompanyControl(item)">delete</v-icon>
         <v-dialog persistent v-model="deleteCompanyDialog" width="60%">
          <v-card>
            <v-card-title>
              <span class="headline">{{deletionCompany.name  + " Firmasını Silmek İstediğinize Emin Misiniz?"}}</span>
            </v-card-title>
            <v-card-text>
              <v-form ref="newUser">
                  <v-container>
              <v-card-subtitle>Seçtiğiniz firmaya ait verileriniz kalıcı olarak silinecektir. Silme işlemini onaylamak için aşağıdaki alana 'Sil' yazınız..</v-card-subtitle
              >
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="deleteValidation"
                  label="Kontrol"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
                  </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Hayır</v-btn>
              <v-btn color="blue darken-1" text :disabled="!buttonControl" @click="deletionCompanyFunc()">Evet</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
     
      
    </v-data-table>
    <v-dialog v-model="companyDetailsDialog" max-width="900">
      <v-card>
        <v-tabs v-model="compoanytDetailsTab">
          <v-tab>Firma Bilgileri</v-tab>
          <v-tab>Firma Abonelik Planı</v-tab>
          <v-tab>Yeminli Mali Müşavir Bilgileri</v-tab>
          <v-tab>Program Ayarları</v-tab>
        </v-tabs>
        <v-tabs-items v-model="compoanytDetailsTab">
          <v-tab-item>
            <v-card flat>
              <CompanyDetailsUpdate
                :popUpStatus="companyDetailsDialog"
                :company="selectedCompanyDetails"
                @refresh="loadCompaniesList()"
              />
            </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-card flat>
              <CompanySubscriptionPlan
                :popUpStatus="companyDetailsDialog"
                :company="selectedCompanyDetails"
                @refresh="loadCompaniesList()"
              />
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <CharteredAccountant
               :popUpStatus="companyDetailsDialog"
               @refresh-company="refreshCompanyById"
               :company="selectedCompanyDetails"
              />
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <CompanySettings
               :popUpStatus="companyDetailsDialog"
               @refresh="loadCompaniesList()"
               :company="selectedCompanyDetails"/>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
    <v-dialog v-model="databaseChoiceDialog" max-width="1250px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{addDatabaseInfoHeadLine}}</span>
        </v-card-title>
        <v-form v-model="databaseChoiceDialogValid">
          <v-container>
            <v-row>
              <v-col cols="12" md="4">
                <v-select
                  v-model="newDatabaseChoiceObj.year"
                  label="Yılı Seçiniz"
                  :items="yearItems"
                  hide-details
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="newDatabaseChoiceObj.erpChoice"
                  label="Erp Seçimi"
                  :items="erpItems"
                  hide-details
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="databaseChoiceDialogCloseFunc()">İptal</v-btn>
          <v-btn
            :disabled="!databaseChoiceDialogValid"
            color="blue darken-1"
            text
            @click="databaseChoiceDialogSaveFunc()" 
          >Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addDatabaseInfoDialog" width="60%" persistent>
            <v-card>
                <v-tabs
                    v-model="addDataBaseTab"
                    background-color="blue lighten-2"
                    dark
                >
                    <v-tab
                        v-for="n in descriptionLength"
                        :key="n.headers"
                    >
                    {{ n.headers }}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="addDataBaseTab">
                    <v-tab-item
                        v-for="(descriptionLength) in descriptionLength"
                        :key="descriptionLength.headers"
                    > 
                      <template v-if="descriptionLength.choice == 'Netsis'">
                        <v-col style="margin-left:18%" cols="8">
                            <!-- <v-textarea
                                height="100%"
                                :key="descriptionLength.items"
                                outlined
                                v-model="despricationObj[i]"
                                label ="Notlarınız"
                            ></v-textarea> -->
                             <v-text-field
                                v-model="descriptionLength.branchCode"
                                label="Şube Kodu"
                                :rules="[rules.required]"
                              ></v-text-field>
                              <v-text-field
                                v-model="descriptionLength.dbName"
                                label="Veri Tabanı Adı"
                                :rules="[rules.required]"
                              ></v-text-field>
                        </v-col>
                      </template>
                      <template v-if="descriptionLength.choice == 'Canias'">
                        <v-col style="margin-left:18%" cols="8">
                          <v-text-field
                             v-model="descriptionLength.username"
                             label="Kullanıcı Adı"
                             :rules="[rules.required]"
                           ></v-text-field>
                           <v-text-field
                             v-model="descriptionLength.password"
                             label="Şifre"
                             :rules="[rules.required]"
                           ></v-text-field>
                        </v-col>
                      </template>
                    </v-tab-item>
                </v-tabs-items>
                <v-card-text class="text-center">
                    <v-btn
                        text
                        @click="newDescriptionTab('delete', descriptionLength)"
                    >
                    Bu Yılı Sil
                    </v-btn>
                    <v-divider
                      class="mx-4"
                      vertical
                    ></v-divider>
                    <v-btn
                      text
                      @click="newDescriptionTab('add')"
                    >
                      Yeni Yıl Ekle
                    </v-btn>
                    <v-btn
                      text
                      @click="newDescriptionTab('close')" 
                    >
                      Kapat
                    </v-btn>
                    <v-btn
                      text
                      @click="newDescriptionTab('cancel')"
                    >
                      İptal Et
                    </v-btn>
                </v-card-text>
            </v-card>
    </v-dialog>

    <Loader></Loader>
  </div>
</template>

<script>
import * as userReq from "../../request/user.js";
import CompanyDetailsUpdate from "../subComponents/CompanyDetailsUpdate.vue";
import CompanySubscriptionPlan from "../subComponents/CompanySubscriptionPlan.vue";
import CharteredAccountant from "../subComponents/CharteredAccountant";
import CompanySettings from "../subComponents/CompanySettings";
import Loader from "./loader";
export default {
  name: "CompanyListTable",
  components: { CompanyDetailsUpdate, CompanySubscriptionPlan, CharteredAccountant, CompanySettings, Loader },
  data() {
    return {
      addDataBaseTab : null,
      despricationObj : {},
      descriptionLength : [],
      addDatabaseInfoDialog : false,
      yearItems : [
        "2010","2011","2012","2013","2014","2015","2016","2017","2018","2019","2020","2021","2022"
      ],
      erpItems : [
        "Canias", "S.A.P", "Netsis"
      ],
      newDatabaseChoiceObj : {
        year : "",
        erpChoice : ""
      },
      databaseChoiceDialogValid : false,
      databaseChoiceDialog : false,
      addDatabaseInfoHeadLine : "Veri Tabanı Seçimi",
      buttonControl: false,
      deleteCompanyDialog: false,
      modal1: false,
      modal: false,
      valid: false,
      periodCheckBox: false,
      exemptCompanyCheckBox: false,
      startingPeriod: null,
      endPeriod: null,
      dateMenu: false,
      periodDialog: false,
      DeadlineDateMenu: false,
      showAll: false,
      search: "",
      dialog: false,
      compoanytDetailsTab: null,
      companyDetailsDialog: false,
      selectedCompanyDetails: {},
      kdvRateSelectionItems: ["Oranlama", "Maksimum"],
      algorithmTypes: ["FIFO","LIFO"],
      currStep: 1,
      stepsCount: 4,
      deleteValidation: null,
      formsRefs: [
        "newCompanyInfo",
        "newCompanyAdmin",
        "newCompanyCharAcc",
        "newCompanySettings",
      ],
      rules: {
        required: (val) => !!val || "Gerekli.",
        counter: (val) =>
          val.toString().length == 11 || "Vergi No 11 rakam olmalı",
        isNumber: (val) => Number.isInteger(val) || "Bu alan rakam olmalı",
        tinNumber: (value) => (value && value.length >= 10 && value.length <= 11 ) || "En az 10 veya 11 karakter gerekli",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Geçersiz Email";
        },
      },
      headers: [
        { text: "Ünvan", width: "250", value: "name", align: "center" },
        {
          text: "Vergi Kimlik Numarası",
          width: "200",
          value: "tinNumber",
          align: "center",
        },
        {
          text: "Çalışan Sayısı",
          value: "workersNumber",
          align: "center",
        },
        {
          text: "Aktif/Pasif",
          value: "isActive",
          sortable: false,
          align: "center",
        },
        {
          text: "Şehir",
          width: "100",
          value: "info.city",
          sortable: false,
          align: "center",
        },
        { text: "Sektör", width: "100", value: "info.sector", align: "center" },
        { text: "Son Kullanma Tarihi", width: "170", value: "deadlineLoggedin", align: "center" },
        { text: "Başlangıç Tarihi", width: "150", value: "startingPeriod", align: "center" },
        { text: "Bitiş Tarihi", width: "150", value: "endPeriod", align: "center" },
        { text: "Firma Yaratma Tarihi", width: "150", value: "creationDate", align: "center" },
        { text: "Detay", value: "detay", sortable: false, align: "center" },
        
      {
        text: "Şirket Sil",
        width: "50",
        value: "delete",
        sortable: false,
        align: "center",
      },
      ],
      deletionCompany: {},
      companyList: [],
      newCompanyTemplate: {
        settings: {
          algorithmType: "FIFO",
          yuklenimSelection: "Oranlama",
          dbInfos : []
        },
        info: {},
        admin: {},
        charAcc: {},
      },
    };
  },
  created() {
    this.loadCompaniesList();
  },
  watch: {
    dialog(val) {
      if (val == false) {
        this.newCompanyTemplate = {
          settings: {
            algorithmType: "FIFO",
            yuklenimSelection: "Oranlama"
          },
          info: {},
          admin: {},
          charAcc: {},
        }
      }
    },
    "deleteValidation": function (newValue) {
      console.log(this.buttonControl)
      if (newValue == "Sil") {
        this.buttonControl = true
      }else{
        this.buttonControl = false
      }
    },
    "periodCheckBox": function (newValue) {
      if (newValue) {
        this.periodDialog = true
      }
    },
    stepsCount(val) {
      if (this.currStep > val) {
        this.currStep = val;
      }
    },
  },
  methods: {
    deleteCompanyControl(item){
      this.deletionCompany = item
      this.deleteCompanyDialog = true
    },
    deletionCompanyFunc(){
      this.$store.commit("LOADER", true);
      userReq.deleteCompany(this.deletionCompany.id)
        .then((res) => {
          this.$store.commit("LOADER", false);
          this.deleteCompanyDialog = false
          this.$store.state.snackbarErrorObj = {
            snackbar: true,
            color: "success",
            text: res.data.data.value,
            timeout: 2500
          };
        })
        .catch((err) => {
          console.log(err)
          this.$store.commit("LOADER", false);
          this.$store.state.snackbarErrorObj = {
            snackbar: true,
            color: "error",
            text: "Şirket silme esnasında problem oluştu.",
            timeout: 2500
          };
        });
    },
    periodDialogClose(type){
      if (type == 1) {
        let startingPeriod = this.startingPeriod.split("-")[0] + this.startingPeriod.split("-")[1]
        let endPeriod = this.endPeriod.split("-")[0] + this.endPeriod.split("-")[1]
        if (endPeriod <= startingPeriod) {
          this.$store.state.snackbarErrorObj = {
            snackbar: true,
            color: "error",
            text: "Başlangıç tarihi bitiş tarihinden küçük veya eşit olamaz.",
            timeout: 2500
          };
        }else{
          this.newCompanyTemplate.settings.startingPeriod = this.startingPeriod
          this.newCompanyTemplate.settings.endPeriod = this.endPeriod
          this.periodDialog = false;
        }
      }else if(type == 0){
        this.periodCheckBox = false
        this.periodDialog = false;
        this.startingPeriod = null
        this.endPeriod = null
      }
    },
    parseDate:function  (date) {
      if (!date) return null
       var arr= date.split('-'),
       day = arr[2],
       month =  arr[1],
       year =  arr[0];
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    isValidForm() {
      let index = this.currStep - 1;
      let form = this.formsRefs[index];
      if (this.$refs[form] != undefined) {
        return this.$refs[form].validate();
      } else return false;
    },
    nextStep() {
      if (this.currStep === this.stepsCount && this.chackAllForms()) {
        this.save()
        this.currStep = 1;
      } else {
        if (this.isValidForm()) {
          ++this.currStep;
        }
      }
    },
    chackAllForms() {
      for (let i = 0; i < this.stepsCount; i++) {
        if (!this.$refs[this.formsRefs[i]].validate()) {
          this.currStep = i + 1;
          return false;
        }
      }
      return true;
    },
    loadCompaniesList() {
      this.$store.commit("LOADER", true);
      userReq
        .getCompanyList()
        .then((res) => {
          let companyListArray = res.data.data.value
          for (let i = 0; i < companyListArray.length; i++) {
            companyListArray[i].deadlineLoggedin = new Date(companyListArray[i].deadlineLoggedin)
            companyListArray[i].deadlineLoggedin.setHours(15)
            res.data.data.value[i].deadlineLoggedin = String(companyListArray[i].deadlineLoggedin.getFullYear())+ "-" + String(companyListArray[i].deadlineLoggedin.getMonth() + 1).padStart(2, '0') +"-"+ String(companyListArray[i].deadlineLoggedin.getDate()).padStart(2, '0')
            if (companyListArray[i].creationDate != null) {
              companyListArray[i].creationDate = new Date(companyListArray[i].creationDate)
            companyListArray[i].creationDate.setHours(15)
            res.data.data.value[i].creationDate = String(companyListArray[i].creationDate.getFullYear())+ "-" + String(companyListArray[i].creationDate.getMonth() + 1).padStart(2, '0') +"-"+ String(companyListArray[i].creationDate.getDate()).padStart(2, '0')
            }
            companyListArray[i].startingPeriod = companyListArray[i].settings.startingPeriod
            companyListArray[i].endPeriod = companyListArray[i].settings.endPeriod
          }
          console.log(res.data.data.value)
          this.companyList = res.data.data.value;
        })
        .catch((err) => {
          console.log(err);
        });
      this.$store.commit("LOADER", false);
    },
    close() {
      this.deletionCompany = {};
      this.deleteValidation = null;
      this.deleteCompanyDialog = false;
      this.dialog = false;
    },
    save() {
      this.$store.commit("LOADER", true);
      this.newCompanyTemplate.settings.exemptCompany = this.exemptCompanyCheckBox
      userReq.addCompany(this.newCompanyTemplate).then((res) => {
          if (res.data.success) {
            this.dialog = false;
            this.loadCompaniesList();
            this.$store.commit("LOADER", false);
            this.$store.state.snackbarErrorObj = {
              snackbar: true,
              color: "success",
              text: "Kaydedildi",
              timeout: 1500
            };
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeStatus(id, status) {
      userReq.updateCompanyStatus(id, status).then((response) => {
          if (response.data.data.value == 1) {
            for (let i = 0; i < this.companyList.length; i++) {
              if (this.companyList[i].id == id) {
                this.companyList[i].isActive = status;
                break;
              }
            }
          }
        })
        .catch((err) => console.log(err));
      console.log(id, status);
    },
    refreshCompanyById(propName,obj) {
      let index = this.companyList.findIndex(x => x.id == obj.id);
      this.companyList[index][propName] = obj.value
    },
    companyDetailsModal(company) {
      this.selectedCompanyDetails = company;
      this.companyDetailsDialog = true;
    },
    databaseChoiceDialogSaveFunc () {
      this.descriptionLength.push({
        headers : this.newDatabaseChoiceObj.year,
        choice : this.newDatabaseChoiceObj.erpChoice
      }) 
      this.databaseChoiceDialog = false
      this.addDatabaseInfoDialog = true
    },
    newDescriptionTab (type) {
      if (type == 'add') {
        this.databaseChoiceDialog = true
      }else if (type ==  'close') {
        this.addDatabaseInfoDialog = false
        this.newCompanyTemplate.settings.dbInfos = this.descriptionLength
      }else if (type ==  'cancel') {
        this.descriptionLength = []
        this.addDatabaseInfoDialog = false
      }else if (type == 'delete') {
        console.log()
        this.descriptionLength.splice(this.addDataBaseTab, 1);
      }
    }
  },
  computed: {},
};
</script>

<style scoped></style>